// extracted by mini-css-extract-plugin
export default {"container":"Row_container__cAEio"};